import React, { useState } from "react";
import {
  Dialog,
  useTheme,
  Stack,
  DialogContent,
  TextField,
  Grid,
  Typography,
  IconButton,
  SvgIcon,
} from "@mui/material";
import CustomButton from "../../components/CustomButton";
import { tokens } from "../../theme";
import { useEffect } from "react";
import { selectedItems } from "../../config/AppConfig";
import { useAtom } from "jotai";

function FrozenAccountUpdateDialog({
  open,
  onClose,
  onDialogButtonClick,
  onDialogRemoveButtonClick,
  data,
}) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selectedItem, setSelectedItem] = useAtom(selectedItems);


  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  useEffect(() => {
    setSelectedFile(null)
    if (data) {
      const value = {
        company: data.companyName,
        code: data.companyCode,
        vendorCode: data.vendorCode,
        frozenReason: data.freezeReason,
        //pic:data.pic,
        accountNo: data.bankAccountNumber,
        bank: data.bankName,
      };
      setFormData(value);
    }

    setDialogOpen(open);
  }, [open, data]);

  const [formData, setFormData] = useState({
    company: "",
    code: "",
    vendorCode: "",
    frozenReason: "",
    // pic:"Kelly",
    accountNo: "",
    bank: "",
  });
  const [errors, setErrors] = useState({});

  const [dialogOpen, setDialogOpen] = useState(open);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleRemove = (e) => {
    e.preventDefault();
    // Validation logic
    const newErrors = {};

    if (!formData.company.trim()) {
      newErrors.company = "Company Name is required";
    }

    if (!formData.code) {
      newErrors.code = "Code is required";
    }

    // if (!formData.vendorCode) {
    //   newErrors.vendorCode = "Vndor Code is required";
    // }

    if (!formData.frozenReason) {
      newErrors.frozenReason = "Reason is required";
    }

    // if (!formData.pic) {
    //   newErrors.pic = "Pic is required";
    // }

    if (!formData.accountNo) {
      newErrors.accountNo = "Account number is required";
    }

    if (!formData.bank) {
      newErrors.bank = "Bank name is required";
    }
    if (Object.keys(newErrors).length === 0) {
      // Form is valid, submit the data

      // Close the dialog
      onClose();

      // onDialogButtonClick(selectedItem, formData);
      onDialogRemoveButtonClick(selectedItem, formData);
      // You can perform additional actions like sending data to a server here
    } else {
      // Form is not valid, update the errors state
      setErrors(newErrors);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Validation logic
    const newErrors = {};

    if (!formData.company.trim()) {
      newErrors.company = "Company Name is required";
    }

    if (!formData.code) {
      newErrors.code = "Code is required";
    }

    // if (!formData.vendorCode) {
    //   newErrors.vendorCode = "Vndor Code is required";
    // }

    if (!formData.frozenReason) {
      newErrors.frozenReason = "Reason is required";
    }

    // if (!formData.pic) {
    //   newErrors.pic = "Pic is required";
    // }

    if (!formData.accountNo) {
      newErrors.accountNo = "Account number is required";
    }

    if (!formData.bank) {
      newErrors.bank = "Bank name is required";
    }
    if (Object.keys(newErrors).length === 0) {
      // Form is valid, submit the data

      // Close the dialog
      onClose();

      onDialogButtonClick(selectedItem, formData,selectedFile);

      // You can perform additional actions like sending data to a server here
    } else {
      // Form is not valid, update the errors state
      setErrors(newErrors);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg">
      <DialogContent>
        <Grid container direction={"column"}>
          <Grid container>
            <Grid container justifyContent="center" alignItems="center" item>
              <Typography fontWeight={"600"} variant="h3" p={1}>
                Frozen Account
              </Typography>
            </Grid>
            <Grid container justifyContent="center" alignItems="center" item>
              <Typography fontSize={"16px"} fontWeight={"400"} pb={4}>
                Details
              </Typography>
            </Grid>
          </Grid>

          <form>
            <Grid container direction={"column"}>
              <Grid
                container
                xs={12}
                alignItems={"center"}
                spacing={3}
                pb={0.5}
              >
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                    variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                    Company
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Company"
                    type="text"
                    name="company"
                    disabled
                    fullWidth
                    value={formData.company}
                    onChange={handleInputChange}
                    error={Boolean(errors.company)}
                    helperText={errors.company}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                xs={12}
                alignItems={"center"}
                spacing={3}
                pb={0.5}
              >
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                    variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                    Code
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Code"
                    type="text"
                    name="code"
                    disabled
                    fullWidth
                    value={formData.code}
                    onChange={handleInputChange}
                    error={Boolean(errors.code)}
                    helperText={errors.code}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                xs={12}
                alignItems={"center"}
                spacing={3}
                pb={0.5}
              >
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                    variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                    Vendor Code
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Vendor Code"
                    type="text"
                    disabled
                    name="vendorCode"
                    fullWidth
                    value={formData.vendorCode}
                    onChange={handleInputChange}
                    error={Boolean(errors.vendorCode)}
                    helperText={errors.vendorCode}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                xs={12}
                alignItems={"center"}
                spacing={3}
                pb={0.5}
              >
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                    variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                    Frozen Reason
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Frozen Reason"
                    type="text"
                    name="frozenReason"
                    fullWidth
                    value={formData.frozenReason}
                    onChange={handleInputChange}
                    error={Boolean(errors.frozenReason)}
                    helperText={errors.frozenReason}
                  />
                </Grid>
              </Grid>

              {/* <Grid container xs={12} alignItems={"center"} spacing={3}  pb={.5}>
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                     variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                   PIC
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                   inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="PIC"
                    type="text"
                    name="pic"
                    fullWidth
                    value={formData.pic}
                    onChange={handleInputChange}
                    error={Boolean(errors.pic)}
                    helperText={errors.pic}
                  />
                </Grid>
              </Grid> */}

              <Grid
                container
                xs={12}
                alignItems={"center"}
                spacing={3}
                pb={0.5}
              >
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                    variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                    Account no.
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Account No."
                    type="text"
                    name="accountNo"
                    disabled
                    fullWidth
                    value={formData.accountNo}
                    onChange={handleInputChange}
                    error={Boolean(errors.accountNo)}
                    helperText={errors.accountNo}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                xs={12}
                alignItems={"center"}
                spacing={3}
                pb={0.5}
              >
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                    variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                    Bank
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Bank"
                    type="text"
                    name="bank"
                    disabled
                    fullWidth
                    value={formData.bank}
                    onChange={handleInputChange}
                    error={Boolean(errors.bank)}
                    helperText={errors.bank}
                  />
                </Grid>
              </Grid>


              <input
                accept="*"
                style={{ display: 'none' }}
                id="file-upload"
                type="file"
                variant="outlined"
                label="Optional"
                onChange={handleFileChange}
                />

                <label style={{  fontSize: "11px",  fontWeight: "500", }}>Attachment (Optional)</label>

                <label htmlFor="file-upload" style={{
                  border:"1px solid #94B0E0", 
                  borderRadius:"34px",
                  width:"100%", 
                  textAlign:"center",
                  margin:"5px auto",
                  fontSize: "10px",
                  fontWeight: "600",
                  letterSpacing: "1.25px",
                  padding: "2px 4px",
                  textTransform : "uppercase",
                  cursor:"pointer"
                  }} >
                  <IconButton color="primary" component="span">
                    <SvgIcon sx={{ width:"32px", height:"auto" }}>
                    <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M26.7987 31.8646C28.9204 31.8804 30.9629 31.0887 32.5304 29.6637C37.7079 25.1354 34.9371 16.0471 28.1129 15.1921C25.6746 0.40375 4.34708 6.00875 9.39791 20.0846" stroke="#292D32" stroke-width="2.375" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12.0263 20.7317C11.1872 20.3042 10.253 20.0825 9.31883 20.0983C1.9405 20.6208 1.95633 31.3558 9.31883 31.8783" stroke="#292D32" stroke-width="2.375" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M25.5488 15.8542C26.3722 15.4426 27.2588 15.2209 28.1772 15.2051" stroke="#292D32" stroke-width="2.375" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M17.8691 35.0293V25.5293" stroke="#292D32" stroke-width="2.375" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M13.6738 29.485L17.7272 25.4316L21.7805 29.485" stroke="#292D32" stroke-width="2.375" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    </SvgIcon>
                  </IconButton>
                  {selectedFile ? selectedFile.name : "Upload Attachment"}
                </label>

              <Stack
                direction="row"
                pt={2}
                spacing={2}
                justifyContent={"center"}
              >
                <CustomButton
                  btnBG={colors.primary[900]}
                  btnColor={colors.grey[100]}
                  btnTxt={"UNFREEZE"}
                  btnBorder={"1px solid" + colors.primary[800]}
                  onClick={handleRemove}
                ></CustomButton>

                <CustomButton
                  btnBG={colors.primary[100]}
                  btnColor={colors.grey[900]}
                  btnTxt={"SAVE"}
                  btnBorder={"1px solid" + colors.primary[100]}
                  onClick={handleSubmit}
                ></CustomButton>
              </Stack>
            </Grid>

            {/* Add more fields as needed */}
          </form>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default FrozenAccountUpdateDialog;
